import { useEffect, useState } from 'react';

import type { FeatureFlagsService } from '../application';

export const useFeatureFlag = <FeatureFlag extends string = string>({
  name,
  featureFlagsService,
}: {
  name: FeatureFlag;
  featureFlagsService: FeatureFlagsService<FeatureFlag>;
}) => {
  const [value, setValue] = useState(() => featureFlagsService.get(name));

  useEffect(() => {
    const listener = (newValue: boolean) => {
      setValue(newValue);
    };
    featureFlagsService.addListener(name, listener);

    return () => {
      featureFlagsService.removeListener(name, listener);
    };
  }, [featureFlagsService, name]);

  return value;
};
